export type TimelineNode = {
  time: string;
  title: string;
  desc: string;
  kind: "爆料" | "回应" | "反转" | "进展";
  verified: boolean;
};

export type Story = {
  id: string;
  title: string;
  summary: string;
  category: string;
  status: "追踪中" | "已反转" | "已回应";
  cover: string;
  author: string;
  date: string;
  heat: number;
  views: number;
  tags: string[];
  featured?: boolean;
  timeline: TimelineNode[];
  content: string[];
};

export const stories: Story[] = [
  {
    id: "jiuchongque-huanjiao",
    title: "古装大剧《九重阙》临开机换角，片方与演员方各执一词",
    summary:
      "距离开机只剩三天，原定女主角被临时替换，流出的统筹消息与演员方口径并不一致，「档期冲突」这个说法遭到了质疑。",
    category: "线索速报",
    status: "追踪中",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20abstract%20editorial%20background%20of%20deep%20crimson%20stage%20curtain%20folds%20with%20dramatic%20side%20lighting%2C%20floating%20dust%20particles%2C%20cinematic%20texture%2C%20no%20people%2C%20generous%20negative%20space%2C%20high%20detail%20photographic%20mood&width=1200&height=800&seq=hg-lead-curtain&orientation=landscape",
    author: "编辑部 · 瓜田观察组",
    date: "2026-09-10",
    heat: 98,
    views: 26400,
    tags: ["换角", "九重阙", "档期冲突"],
    featured: true,
    timeline: [
      {
        time: "08-28 21:40",
        title: "统筹表截图流出",
        desc: "一份标注「最终版」的拍摄统筹表在剧组交流群流出，女主角一栏被人为涂改，替换姓名以首字母标注。",
        kind: "爆料",
        verified: true,
      },
      {
        time: "09-02 15:10",
        title: "演员方回应：档期冲突",
        desc: "演员工作室发布简短说明，称因后续项目档期重叠，双方「友好协商后决定终止合作」，未提及具体替代人选。",
        kind: "回应",
        verified: true,
      },
      {
        time: "09-05 11:20",
        title: "制片人点赞引发新猜测",
        desc: "制片人在一条质疑「档期说法站不住脚」的网友评论下点赞，随后取消，被指态度微妙。",
        kind: "进展",
        verified: false,
      },
      {
        time: "09-10 09:00",
        title: "补拍计划被指调整",
        desc: "有消息称剧组已将前两集拍摄顺序整体后移，疑似为新面孔留出定妆与磨合时间。截至发稿，片方未正式回应。",
        kind: "进展",
        verified: false,
      },
    ],
    content: [
      "《九重阙》原定于九月初在横店开机，前期已经完成围读与定妆。按照常规流程，此时演员阵容基本不会再有大的变动，因此这份标注「最终版」的统筹表被替换，才让外界感到意外。",
      "从流出截图看，被替换的姓名以首字母代替，改动痕迹明显，旁边还有一行手写批注，内容为「按新档期走」。这份截图目前无法确认出自剧组核心成员，我们将其标注为待核实信源。",
      "演员方在四天后给出回应，口径集中在「档期冲突」与「友好协商」。但多位剧组工作人员的说法指向另一种可能：双方对拍摄周期与后期配合的分歧在先，档期只是对外统一的表述。",
      "值得注意的是，制片人短暂点赞又取消的举动，被不少网友解读为对演员方说法的不满。点赞本身不构成任何事实，我们把它作为氛围指标记录在时间线中，不作为结论依据。",
      "截至目前，片方尚未发布正式声明，替代人选也未官宣。我们会持续跟进选角确认与开机实况，任何新节点都会追加到这条时间线。",
    ],
  },
  {
    id: "yinyuejie-jianqu",
    title: "某音综被指剪辑断章取义，歌手现场发言完整版流出后风向转了",
    summary:
      "节目正片片段引发争议后，一段更完整的现场收音被放了出来，前后语境差别不小，讨论焦点从歌手转向了后期。",
    category: "反转现场",
    status: "已反转",
    cover:
      "https://readdy.ai/api/search-image?query=Macro%20abstract%20shot%20of%20vintage%20studio%20condenser%20microphone%20against%20dark%20acoustic%20foam%20wall%2C%20warm%20amber%20rim%20light%2C%20shallow%20depth%20of%20field%2C%20no%20people%2C%20editorial%20music%20magazine%20mood&width=800&height=600&seq=hg-live-mic&orientation=landscape",
    author: "编辑部 · 声浪组",
    date: "2026-09-08",
    heat: 91,
    views: 31800,
    tags: ["综艺剪辑", "断章取义", "现场收音"],
    timeline: [
      {
        time: "08-30 20:00",
        title: "正片片段引争议",
        desc: "节目播出后，一段约十二秒的片段被大量转发，歌手在点评环节的发言被解读为「当场否定另一位嘉宾」。",
        kind: "爆料",
        verified: true,
      },
      {
        time: "09-01 10:30",
        title: "节目组：属正常剪辑",
        desc: "节目组回应称剪辑节奏经过整体考量，不存在刻意引导，但未公布完整素材。",
        kind: "回应",
        verified: true,
      },
      {
        time: "09-06 18:45",
        title: "完整收音流出，语境反转",
        desc: "一段近两分钟的现场收音流出，显示该发言前后均有调侃与补充，被剪掉的后半句恰好是缓和语气的内容。",
        kind: "反转",
        verified: true,
      },
      {
        time: "09-08 09:15",
        title: "歌手方不再追究",
        desc: "歌手工作室表示理解节目时长限制，希望讨论回到音乐本身，事件就此收束。",
        kind: "回应",
        verified: true,
      },
    ],
    content: [
      "争议片段里，歌手在看完舞台后说了一句「这个处理我不太认可」，随后镜头直接切到另一位嘉宾的反应。单看这十二秒，确实容易得出「当场否定」的结论。",
      "完整收音流出后，情况变得清晰：那句话后面紧跟着「但我理解他为什么这么改」，并且歌手紧接着用三句话解释了自己的判断标准。被剪掉的后半句，恰恰是缓和语气的关键。",
      "我们曾就此事联系节目组，得到的答复是「剪辑需服务整体叙事」。这一点在行业内并不罕见，但当省略造成了语义层面的反向理解时，它就不再只是节奏问题。",
      "反转出现后，舆论焦点从歌手个人转向了后期剪辑标准。多位同行从业者借此事讨论综艺「悬念剪辑」的边界，也有观众开始重新审视此前几期节目。",
      "歌手方最终选择不再追究，事件告一段落。这条时间线完整保留了争议片段与完整收音两个节点，方便对照理解整个反转是怎么发生的。",
    ],
  },
  {
    id: "paihang-shuju-zhiyi",
    title: "音乐榜单数据被质疑异常，平台公布清洗规则后仍留疑问",
    summary:
      "某周榜单前十出现多首空降作品，播放曲线高度集中，平台公布了一版数据清洗说明，但没解释最关键的凌晨时段。",
    category: "当事人回应",
    status: "已回应",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20data%20visualization%20texture%20of%20glowing%20warm%20orange%20bar%20charts%20on%20deep%20charcoal%20glass%20surface%2C%20night%20tone%2C%20reflections%2C%20no%20people%2C%20clean%20editorial%20technology%20mood&width=800&height=600&seq=hg-chart-data&orientation=landscape",
    author: "编辑部 · 数据组",
    date: "2026-09-06",
    heat: 76,
    views: 18200,
    tags: ["榜单", "数据异常", "平台回应"],
    timeline: [
      {
        time: "09-03 09:00",
        title: "榜单异常被网友发现",
        desc: "有网友统计发现，该周前十中有三首作品的播放量集中在凌晨两点到四点，且曲线形状高度相似。",
        kind: "爆料",
        verified: true,
      },
      {
        time: "09-04 16:20",
        title: "平台发布清洗说明",
        desc: "平台称已剔除异常播放，并公布了计入口径，但未提供分时段数据，也未解释曲线相似的原因。",
        kind: "回应",
        verified: true,
      },
      {
        time: "09-06 11:00",
        title: "争议未完全平息",
        desc: "多位业内人士认为说明方向正确但仍不够具体，呼吁公开更细颗粒度的数据。",
        kind: "进展",
        verified: false,
      },
    ],
    content: [
      "异常最早由一位长期做榜单统计的网友发现。他把自己记录的分时段数据整理成图表，三首作品的凌晨播放占比都超过全天四成，这在自然收听场景中相当罕见。",
      "平台在次日给出了回应，说明中列出了计入范围、重复播放去重逻辑与设备识别方式，整体口径是「数据经过清洗，异常部分已剔除」。",
      "问题出在，这份说明没有回答最初的那个疑问：为什么三首毫无关联的作品会呈现几乎一致的凌晨曲线。缺少分时段数据，让解释停留在原则层面，而外界关心的是具体证据。",
      "我们的判断是，平台回应具备一定诚意，方向上也在往透明走，但目前的公开程度还不足以彻底平息质疑。这条时间线会继续记录后续是否会有更细的数据披露。",
    ],
  },
  {
    id: "hezuo-tingzhi-queren",
    title: "品牌方连夜撤下联名海报，合作是否中止一夜之间传了三个版本",
    summary:
      "同一晚出现了「合约到期」「主动解约」「只是物料轮换」三种说法，我们逐一核对了时间点和信源，理清了先后顺序。",
    category: "线索速报",
    status: "追踪中",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20outdoor%20advertising%20lightbox%20frame%20at%20night%20on%20a%20quiet%20city%20street%2C%20warm%20streetlight%20glow%2C%20light%20rain%20on%20pavement%2C%20no%20people%2C%20cinematic%20urban%20editorial%20mood&width=800&height=600&seq=hg-billboard-void&orientation=landscape",
    author: "编辑部 · 瓜田观察组",
    date: "2026-09-05",
    heat: 84,
    views: 22100,
    tags: ["品牌合作", "物料下架", "合约"],
    timeline: [
      {
        time: "09-04 22:30",
        title: "海报连夜撤下",
        desc: "多地网友拍到联名海报在当晚被撤换，替换为品牌常规视觉，时间集中在同一小时区间。",
        kind: "爆料",
        verified: true,
      },
      {
        time: "09-05 00:40",
        title: "『主动解约』说法流出",
        desc: "有账号称品牌方单方面终止合作，但未提供任何书面依据，我们不将其列为已核实信息。",
        kind: "爆料",
        verified: false,
      },
      {
        time: "09-05 08:10",
        title: "『物料轮换』说法出现",
        desc: "接近品牌方的人士称，本次属于既定投放周期的物料轮换，与合作状态无关。",
        kind: "回应",
        verified: false,
      },
      {
        time: "09-05 20:00",
        title: "双方均未正式表态",
        desc: "截至发稿，品牌方与艺人方都没有发布正式说明，三种说法并存。",
        kind: "进展",
        verified: true,
      },
    ],
    content: [
      "事件的起点很具体：多个城市在同一晚、相近时间撤下了同一组联名海报。对投放节奏敏感的用户很快注意到这个「同一时间」的巧合。",
      "紧接着出现了第一个说法——品牌方主动解约。这条信息来自一个匿名账号，没有任何合同、通知或官方文件支撑，我们将其归入待核实。",
      "第二个说法在次日早上出现，称这只是一次常规物料轮换。这个解释在时间上说得通，但也同样缺少第三方佐证。",
      "第三个说法则来自更早的观察者：这批海报的投放周期本身就在九月初到期。如果属实，撤换是提前排好的计划，与近期任何传闻无关。",
      "目前三种版本都无法被完全证实。我们把它保留为开放时间线，等任何一方给出正式说明后再做更新。这恰好也是我们坚持「一条线索一条时间线」的原因——急不得。",
    ],
  },
  {
    id: "tvju-buling-wangluo",
    title: "网传某剧组补领拖欠片酬，制片方否认，群演晒出行程单",
    summary:
      "关于片酬发放的说法两边完全对不上。一位群演晒出的行程与结算记录，让讨论从「有没有」变成了「发给了谁」。",
    category: "线索速报",
    status: "追踪中",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20film%20set%20at%20dusk%20with%20empty%20director%20chairs%2C%20cable%20coils%20and%20soft%20amber%20work%20lights%2C%20misty%20air%2C%20no%20people%2C%20moody%20documentary%20editorial%20photography&width=800&height=600&seq=hg-film-set-night&orientation=landscape",
    author: "编辑部 · 片场线人",
    date: "2026-09-03",
    heat: 72,
    views: 15600,
    tags: ["片酬", "群演", "剧组"],
    timeline: [
      {
        time: "08-29 14:00",
        title: "补领片酬传闻出现",
        desc: "有自称剧组成员的网友称，部分工作人员的劳务费已拖欠两个结算周期。",
        kind: "爆料",
        verified: false,
      },
      {
        time: "09-01 17:30",
        title: "制片方否认拖欠",
        desc: "制片方回应称所有劳务均按合同节点发放，不存在拖欠，并提示警惕不实信息。",
        kind: "回应",
        verified: true,
      },
      {
        time: "09-03 10:20",
        title: "群演晒出行程与结算单",
        desc: "一位群演公开了自己九天的驻组行程与部分结算记录，显示存在结算时间与合同约定不一致的情况。",
        kind: "进展",
        verified: true,
      },
    ],
    content: [
      "最初的传闻指向整个剧组，涉及面很宽，也因此很难核实。制片方的否认同样是整体性的，双方在「有没有拖欠」这个问题上完全对不上。",
      "转折出现在一位群演的晒单。他没有谈整个剧组，只公开了自己九天驻组的行程表和部分到账记录，时间点清楚、金额区间具体。",
      "这份材料说明的是：至少在群演这一层，存在结算时间与合同节点不一致的情况。它不能直接证明「全组拖欠」，但让讨论从笼统的站队变成了可核查的具体问题。",
      "我们倾向于认为，这类争议往往不是非黑即白。不同工种、不同签约主体的结算路径可能完全不同，笼统的「有」或「没有」都容易失真。",
      "这条时间线接下来会重点跟进群演与场务等基层工种的结算情况，如果有更完整的材料，会继续追加节点。",
    ],
  },
  {
    id: "gongzuoshi-gaosu-fengbo",
    title: "工作室起诉自媒体案开庭，双方在「转载」边界上分歧明显",
    summary:
      "原告认为转述失实内容同样构成侵权，被告主张只是搬运公开信息。庭上围绕一条被反复转发的旧帖展开了拉锯。",
    category: "当事人回应",
    status: "已回应",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20abstract%20view%20of%20a%20wooden%20desk%20with%20stacked%20paper%20documents%20and%20a%20brass%20desk%20lamp%2C%20warm%20low%20light%2C%20deep%20shadows%2C%20no%20people%2C%20serious%20editorial%20still%20life&width=800&height=600&seq=hg-courtroom-desk&orientation=landscape",
    author: "编辑部 · 法务观察",
    date: "2026-08-30",
    heat: 68,
    views: 12900,
    tags: ["名誉权", "转载", "诉讼"],
    timeline: [
      {
        time: "07-18 09:00",
        title: "工作室宣布起诉",
        desc: "工作室公告称，多个账号长期转述未经核实的内容，已委托律师固定证据并提起诉讼。",
        kind: "回应",
        verified: true,
      },
      {
        time: "08-22 10:00",
        title: "首次开庭",
        desc: "庭审围绕「转载者是否负有核实义务」展开，被告主张其仅搬运公开信息，未添加评价。",
        kind: "进展",
        verified: true,
      },
      {
        time: "08-30 15:30",
        title: "法庭未当庭宣判",
        desc: "双方均表示愿意在庭后继续沟通，案件将择期继续审理。",
        kind: "进展",
        verified: true,
      },
    ],
    content: [
      "这起案件的争议点并不复杂，却很有代表性：把一条失实内容原样转发，是否同样构成侵权。原告认为，转发扩大了传播范围，不能以「只是搬运」免责。",
      "被告的主张是，其发布时标注了信息来源，也没有添加任何评价性内容，主观上不存在恶意。这一说法在过往类似案件里时常出现，法院的认定标准并不统一。",
      "庭上反复出现的是同一条被转发了上千次的旧帖。它最早出现在一个已注销的账号，此后经过多轮转述，细节在传播中不断被补全，最终变得面目全非。",
      "值得注意的是，双方都表达了庭后继续沟通的意愿。这类案件最终以调解收场的比例不低，但无论结果如何，它对「转载边界」的讨论都有参考价值。",
      "我们会继续跟进后续开庭与判决结果，并在时间线中保留完整的审理节点。",
    ],
  },
  {
    id: "xuanjiu-chengji-yiwen",
    title: "新剧选角公布后争议不断，「空降主演」背后的试镜流程被追问",
    summary:
      "定角名单公布后，更多人在问同一件事：这位主演是怎么进入终选的。剧组只回应了「符合流程」，却没有说明流程是什么。",
    category: "反转现场",
    status: "已反转",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20audition%20room%20with%20a%20single%20wooden%20stool%20under%20soft%20spotlight%2C%20pale%20plaster%20walls%2C%20long%20shadows%2C%20no%20people%2C%20minimal%20editorial%20theatre%20photography&width=800&height=600&seq=hg-audition-hall&orientation=landscape",
    author: "编辑部 · 瓜田观察组",
    date: "2026-08-27",
    heat: 79,
    views: 19700,
    tags: ["选角", "试镜", "空降"],
    timeline: [
      {
        time: "08-20 12:00",
        title: "定角名单公布",
        desc: "主演名单公布后，网络出现对该人选资历与试镜过程的集中质疑。",
        kind: "爆料",
        verified: true,
      },
      {
        time: "08-22 18:00",
        title: "剧组称符合流程",
        desc: "剧组回应表示选角经过多轮试镜，结果「符合流程」，未公开具体轮次与评委构成。",
        kind: "回应",
        verified: true,
      },
      {
        time: "08-25 21:00",
        title: "试镜片段流出，质疑转向",
        desc: "一段终选试镜片段流出，该主演在情绪戏中的完成度获得不少此前质疑者的认可，讨论重心回到表演本身。",
        kind: "反转",
        verified: true,
      },
    ],
    content: [
      "名单公布当晚，讨论几乎一边倒。质疑集中在两点：过往作品不多，以及是否经过正常试镜流程。其中第二点最容易被放大，因为它关乎公平。",
      "剧组的回应相当简短，只表示选角经过多轮试镜、结果符合流程。问题是，「流程」具体包含几轮、由谁参与评审、终选如何定夺，都没有说明，这反而让疑问继续发酵。",
      "三天后流出的终选试镜片段改变了走向。片段中一段情绪转折的处理相当克制，完成度超出不少人预期。此前最激烈的质疑者中，有不少人公开表示「这段确实可以」。",
      "这次反转的关键不在公关，而在内容本身。当具体作品被摆出来，抽象的资历争论自然会退居次位。",
      "我们保留了从质疑到反转的完整节点。需要提醒的是，试镜片段的流出渠道仍未获确认，我们将其标注为待核实来源。",
    ],
  },
  {
    id: "heiyao-jieyue-maodun",
    title: "经纪合约纠纷升级，双方就「独家条款」是否成立递交补充材料",
    summary:
      "解约争议从口头喊话进入材料阶段，焦点落在一份条款表述模糊的补充协议上，双方对同一句话读出了相反的意思。",
    category: "当事人回应",
    status: "追踪中",
    cover:
      "https://readdy.ai/api/search-image?query=Extreme%20close%20up%20of%20a%20fountain%20pen%20resting%20on%20a%20blurred%20printed%20contract%20page%2C%20warm%20desk%20lamp%20light%2C%20shallow%20focus%2C%20no%20readable%20text%2C%20no%20people%2C%20editorial%20legal%20still%20life&width=800&height=600&seq=hg-contract-pen&orientation=landscape",
    author: "编辑部 · 法务观察",
    date: "2026-08-24",
    heat: 64,
    views: 11200,
    tags: ["经纪合约", "解约", "独家条款"],
    timeline: [
      {
        time: "08-10 10:00",
        title: "艺人方提出解约",
        desc: "艺人方发布声明，称原合约存在权利义务不对等情况，要求解除合作。",
        kind: "回应",
        verified: true,
      },
      {
        time: "08-14 16:00",
        title: "公司否认违约",
        desc: "经纪公司回应称合约有效，艺人单方面解约将按约定处理后续事宜。",
        kind: "回应",
        verified: true,
      },
      {
        time: "08-24 09:30",
        title: "双方递交补充材料",
        desc: "争议焦点集中在补充协议中「独家」一词的解释，双方各自提交了往来函件作为佐证。",
        kind: "进展",
        verified: true,
      },
    ],
    content: [
      "纠纷从公开喊话进入了资料阶段，这是这类争议走向务实的信号。双方不再强调态度，而是各自摆出函件与协议文本。",
      "核心争议是一份补充协议里的「独家」表述。艺人方认为该表述限定了具体业务范围，公司则认为它覆盖全部商业合作。同一句话，读出了相反的意思。",
      "这种情况在行业里并不少见。协议在签署时往往追求简洁，留白过多，一旦出现分歧就缺少可执行的判断标准。",
      "目前双方都在补充材料，暂无新的公开表态。我们会在时间线中保留完整的函件往来节点，方便读者理解分歧究竟出在哪。",
    ],
  },
  {
    id: "zongyi-luchang-zhengyi",
    title: "综艺录制现场起争执，多方还原「先后顺序」说法不一",
    summary:
      "关于谁先动怒，现场流出了三种顺序版本。我们把不同来源的时间点并列，发现分歧恰好卡在同一个环节。",
    category: "线索速报",
    status: "已回应",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20television%20studio%20floor%20seen%20from%20above%20with%20overhead%20warm%20lighting%20rigs%20and%20dark%20seating%20blocks%2C%20hazy%20atmosphere%2C%20no%20people%2C%20cinematic%20editorial%20mood&width=800&height=600&seq=hg-studio-lights&orientation=landscape",
    author: "编辑部 · 声浪组",
    date: "2026-08-19",
    heat: 61,
    views: 10400,
    tags: ["综艺录制", "现场争执", "多方说法"],
    timeline: [
      {
        time: "08-16 23:00",
        title: "现场视频片段流出",
        desc: "一段录制间隙的短视频流出，画面中两位嘉宾语气升高，随后被工作人员分开。",
        kind: "爆料",
        verified: true,
      },
      {
        time: "08-17 13:00",
        title: "节目组称已沟通",
        desc: "节目组表示现场沟通已经完成，双方情绪平稳，不影响后续录制。",
        kind: "回应",
        verified: true,
      },
      {
        time: "08-19 19:00",
        title: "三种顺序版本并存",
        desc: "不同来源对争执起因的先后顺序描述不一致，其中关于某个游戏环节是否已结束的说法分歧最大。",
        kind: "进展",
        verified: false,
      },
    ],
    content: [
      "流出的片段只有十几秒，能看到的是结果——语气升高、工作人员介入，看不到起因。短短十几秒被反复分析，还是无法还原过程。",
      "节目组随后回应，强调现场已经沟通完毕。这个回应解决的是当下状态，但没有回答外界最关心的起因。",
      "我们接触到三种顺序版本，共同点是争执发生在某个游戏环节结束后，分歧在于该环节是否真正结束。有的说法认为环节已被叫停，有的则认为仍在进行中。",
      "这个细节看似很小，却直接决定了谁先情绪失控——如果环节已结束，后续发言属于休息时间的私人交流；如果没有结束，那就在录制范畴内。",
      "目前没有更多证据能够确定顺序，我们把三种版本并列保留，不做取舍。这条时间线会保持开放，等待更多现场信息。",
    ],
  },
  {
    id: "shangye-toufang-yiwen",
    title: "商务代言被指集中于同一品类，多方回应「资源倾斜」说法",
    summary:
      "有观察者统计了近一年同类代言分布，认为资源高度集中。被点名的品牌与艺人方均作出回应，但统计口径本身也存在争议。",
    category: "瓜田盘点",
    status: "已回应",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20retail%20storefront%20window%20at%20dusk%20with%20unbranded%20blank%20display%20boxes%20and%20warm%20interior%20glow%2C%20reflective%20pavement%2C%20no%20people%2C%20clean%20commercial%20editorial%20photography&width=800&height=600&seq=hg-retail-window&orientation=landscape",
    author: "编辑部 · 数据组",
    date: "2026-08-15",
    heat: 57,
    views: 9100,
    tags: ["商务代言", "资源分布", "统计口径"],
    timeline: [
      {
        time: "08-11 10:00",
        title: "代言分布统计表流传",
        desc: "一份近一年商务代言统计表被广泛引用，显示同一品类中多个头部资源集中在少数艺人身上。",
        kind: "爆料",
        verified: false,
      },
      {
        time: "08-13 14:00",
        title: "品牌方回应因品类契合",
        desc: "被点名的品牌表示选择标准是品类契合度与目标人群匹配，与外部猜测无关。",
        kind: "回应",
        verified: true,
      },
      {
        time: "08-15 17:00",
        title: "统计口径遭质疑",
        desc: "有从业者指出，该统计混用了不同口径，短代与长约被合并计算，结论因此被放大。",
        kind: "进展",
        verified: true,
      },
    ],
    content: [
      "这类统计最容易引发讨论，因为它把分散的商业决策压缩成一张表，看上去一目了然，也更容易被过度解读。",
      "被点名的品牌回应得很直接：选择依据是品类契合度与目标人群匹配。这个逻辑本身站得住，短期内也确实难以证伪。",
      "真正的问题出在统计方法上。有从业者指出，原表把短期合作与长期合约合并计数，而两者在投入体量与决策层级上完全不同。口径一旦混合，集中度就会被明显放大。",
      "所以我们在这条时间线里特意保留了口径争议这个节点。数据本身可能是真实的，但结论未必成立，这中间隔着方法。",
      "截至目前，各方都给出了回应，事件暂告一段落。我们会在盘点类内容中继续关注类似的统计口径问题。",
    ],
  },
];

export const getStoryById = (id: string): Story | undefined =>
  stories.find((s) => s.id === id);

export const getRelatedStories = (story: Story, limit = 3): Story[] =>
  stories.filter((s) => s.id !== story.id && s.category === story.category).slice(0, limit);